import script from "./ScmSupplier.vue?vue&type=script&setup=true&lang=js"
export * from "./ScmSupplier.vue?vue&type=script&setup=true&lang=js"

import "./ScmSupplier.vue?vue&type=style&index=0&id=3453cda4&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/idaas_web_test/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3453cda4"]])

export default __exports__